function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "37",
  height: "37",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 37 37"
}, props), /*#__PURE__*/React.createElement("rect", {
  x: "6",
  y: "5",
  width: "26",
  height: "27",
  rx: "8",
  fill: "#F9F6F2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.53 9.347c1.447 0 2.896.033 4.344-.008 2.602-.073 4.927 1.975 4.905 4.904-.022 2.897.008 5.795-.008 8.692-.016 2.898-2.025 4.873-4.903 4.894a966.88 966.88 0 0 1-8.751 0c-2.318-.013-4.165-1.44-4.681-3.594a5.095 5.095 0 0 1-.132-1.173c-.01-2.986-.01-5.97 0-8.956 0-1.57.632-2.85 1.878-3.81a4.567 4.567 0 0 1 2.883-.948h4.477l-.013-.001Zm.103 14.79a5.566 5.566 0 0 0 5.55-5.585c-.03-3.07-2.56-5.566-5.612-5.531a5.559 5.559 0 0 0-3.878 9.514 5.559 5.559 0 0 0 3.94 1.607v-.004Zm7.19-11.522a1.296 1.296 0 1 0-1.288 1.29 1.275 1.275 0 0 0 1.289-1.29Z",
  fill: "#600436"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.359 35.702a18.52 18.52 0 0 0 7.113 1.442c10.125.071 18.489-8.18 18.574-18.33A18.542 18.542 0 0 0 18.613.074C8.443.005.088 8.25 0 18.443a18.53 18.53 0 0 0 11.358 17.259Zm8.648-28.434h-.003l-1.47.002-1.554-.003h-.015l-.859-.002c-.705-.002-1.41-.001-2.114.006a7.11 7.11 0 0 0-2.556.5c-2.496.995-4.195 3.384-4.216 6.292a723.743 723.743 0 0 0 0 8.955c.024 3.934 2.958 6.861 6.888 6.881 2.94.015 5.881.015 8.822 0 1.547-.007 2.945-.466 4.072-1.26 1.733-1.222 2.828-3.233 2.846-5.607a555.74 555.74 0 0 0 0-8.89c-.032-3.93-2.97-6.847-6.9-6.874a288.46 288.46 0 0 0-2.068-.002c-.291 0-.582 0-.873.002Z",
  fill: "#600436"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.227 18.591a3.607 3.607 0 0 1-4.32 3.52 3.605 3.605 0 0 1 .72-7.14 3.616 3.616 0 0 1 3.6 3.62Z",
  fill: "#600436"
}));